import type { ReactNode } from "react";

import { Box, Divider, Typography } from "@luce/ui";

interface InvoiceDetailRowProps {
  label: string;
  children: ReactNode;
  divider?: boolean;
}

export function InvoiceDetailRow({ label, children, divider = true }: InvoiceDetailRowProps) {
  return (
    <Box className="gap-spacing-sm flex flex-col">
      <Box className="gap-spacing-md flex flex-row items-center justify-between">
        <Typography variant="body-sm" color="neutral-foreground-intermediate">
          {label}
        </Typography>
        {typeof children === "string" ? (
          <Typography variant="body-sm" color="neutral-foreground-default" align="right">
            {children}
          </Typography>
        ) : (
          children
        )}
      </Box>
      {divider && <Divider />}
    </Box>
  );
}
